import { REQUEST_FAQS, RECEIVE_FAQS } from "./faq.actions";

const requestPagedFaqs = () => {
    return {
        type: REQUEST_FAQS
    };
};

const receivePagedFaqs = faqs => {
    return {
        type: RECEIVE_FAQS,
        faqs
    };
};

export { requestPagedFaqs, receivePagedFaqs };



// WEBPACK FOOTER //
// ./src/actions/faq/faq.creators.js